if (!customElements.get('custom-bundler')) {
  class CustomBundler extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.classList.add('[&.error_.default-message]:hidden', '[&.redeemed_.default-message]:hidden', '[&_.success-message]:hidden', '[&_.error-message]:hidden', '[&.redeemed_.success-message]:block', '[&.error_.error-message]:block');

      const copySection = document.querySelector('.shopify-section.section_copy');
      const stickyCopy = this.querySelector('[data-copy-section]');
      this.products = JSON.parse(this.dataset.productsJson
        .replaceAll('%27', '&apos;')
        .replaceAll('%22', '&quot;')
      );
      this.variants = this.products.map((({ variants }) => variants)).flat();
      // deduplicate variants when they appear in mulitple categories
      this.variants = this.variants.filter((obj1, i, arr) => 
        arr.findIndex(obj2 => 
          ['id', 'url'].every(key => obj2[key] === obj1[key])
        ) === i
      )
      
      this.bundleTitle = this.dataset.bundleName;
      this.displayPrice = this.querySelector('[data-display-price]');
      this.bundleSize = Number(this.dataset.bundleSize);
      this.amountOff = (Math.round(Number(this.dataset.fixedDiscount.replace(/[^\d.]/g, '')) * 100) * this.bundleSize / 100);
      this.updateSelectedProducts(); 
            
      if (copySection && stickyCopy) {
        stickyCopy.innerHTML = copySection.innerHTML;
        stickyCopy.classList.add('hidden', 'md:block', ...copySection.classList);
        copySection.classList.add('md:hidden');
      }
      
      this.addEventListener('fake-select:changed', e => {
        const variant = this.variants.find(({ id }) => id === e.target.value);
        const product = this.products.find(({ handle }) => handle === variant?.parent_handle);
        
        e.target.closest('[data-option-wrap]').querySelector('[data-selected-product-title]').innerHTML = product.title?.split('|')[0]?.split(' x ')[0];
        // this.renderBuyWithPointsButton();
      });
      
      // this.renderBuyWithPointsButton();
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-bundler-action]');
        if(!clickedElement) return;
        
        const {
          bundlerAction: action,
        } = clickedElement.dataset;
        
        switch (action) {
          case 'redeem-for-points':
            this.redeemForPoints();
          break;
          case 'add-to-cart':
            this.selectedVariants = [...this.querySelectorAll('fake-select[data-value][data-product-id]')].map((el) => ({
              variantId: el.dataset.value,
              productId: el.dataset.productId
            }));
            
            let bundleData;
            
            fetch('?section_id=bundle-data')
              .then((response) => response.text())
              .then((text) => {
                bundleData = new DOMParser().parseFromString(text, "text/xml")?.querySelector('script')?.innerHTML;
                if (bundleData) {
                  bundleData = JSON.parse(bundleData);
                }              
              })
              .then(() => {
                if (!bundleData) return;
                
                const bundleId = uuidv4();
                const data = {
                  items: this.selectedVariants.map(({ variantId }) => ({
                    'id': variantId,
                    'quantity': 1,
                    'properties': {
                      ...bundleData,
                      _bundle_id: `${bundleId}`,
                      _bundled_products: `${this.selectedVariants.map(({ variantId }) => variantId).join(',')}`,
                      _bundle_size: this.bundleSize,
                      _bundle_title: `${this.bundleTitle}`,
                    }
                  })),
                  sections: ['minicart']
                };
                
                this.bulkAddToCart(data);
              })
          break;
          default: break;
        }
      });
      
      this.createObserver();
    }
    
    bulkAddToCart(data) {
      const minicart = document.querySelector('mini-cart');

      fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      })
      .then((response) => response.json())
      .then((res) => {
        if (!minicart) return;
        minicart.updateCartHtml(res).then(() => minicart.open())
      })
      .catch(function(err) {
        console.error(err)
      });
    }
    
    updateSelectedProducts() {
      this.selectedVariantIds = [...this.querySelectorAll('fake-select[data-value')].map((el) => el.dataset.value);
      let newBundlePrice = 0;
      let currency = '';
      [...this.querySelectorAll('fake-select[data-value')].forEach(fakeSelect => {
        const variantId = fakeSelect.dataset.value;
        const matchingVariant = this.variants?.find((variant) => Number(variant.id) === Number(variantId));
        const matchingSelectWrapper = fakeSelect?.closest('[data-bundle-selector]');
        const bundleChoiceImage = matchingSelectWrapper?.querySelector('[data-bundle-selector-image] img');
        if (!bundleChoiceImage || !matchingVariant || !matchingVariant?.image) return;
        bundleChoiceImage.src = `${matchingVariant.image.src}`;
        bundleChoiceImage.srcset = `${matchingVariant.image.src}?v=1575994897&width=352 352w`;
        const priceString = matchingVariant.price_money;
        currency = priceString.slice(priceString.indexOf('>') + 1, priceString.indexOf('>') + 2);
        newBundlePrice += Number(priceString.replace(/[^\d.]/g, ''));
      });
      
      const discountPrice = newBundlePrice - this.amountOff;
      const newPriceDisplay = `
        <span class="text-accent1">${currency}${discountPrice.toFixed(2)}</span>
        <span class="line-through">${currency}${newBundlePrice.toFixed(2)}</span>
      `;
      if (newPriceDisplay !== this.displayPrice.innerHTML) this.displayPrice.innerHTML = newPriceDisplay;
    }
    
    renderBuyWithPointsButton() {
      poll(() => window.loyaltyApiAuthed && !!this.querySelector('[data-bundle-atc-wrapper]'), 10000, 150)
        .then(() => {
          const wrapper = this.querySelector('[data-bundle-atc-wrapper]');
          this.selectedVariantIds = [...this.querySelectorAll('fake-select[data-value')].map((el) => el.dataset.value);
          const selectedVariants = [... new Set(this.variants)].filter((x) => this.selectedVariantIds.find(id => id === x.id));
          if (!wrapper || !this.selectedVariantIds || !selectedVariants) return;      
          let accumulatedPointCost = 0;
          
          if (selectedVariants.find(({ available }) => !available)) {
            wrapper.innerHTML = ``;
            return;
          }
          
          Promise.all(this.selectedVariantIds.map(variant_id => loyaltyApi.getPointCost(variant_id, { })
            .then(res => {
              if (res.product_type.toLowerCase() !== 'shaker') {
                accumulatedPointCost += res.point_cost
              }
            }))
            ).then(() =>{
              wrapper.innerHTML = `
               <button 
                  data-bundler-action="redeem-for-points" 
                  type="button" 
                  class="button secondary w-full capitalize peer-disabled:hidden"
                >
                  <span class="default-message">Buy with ${accumulatedPointCost} points</span>
                  <span class="success-message">Redeemed!</span>
                  <span class="error-message">Unable to redeem</span>
                  <div class="loader">
                    <span class="block w-12 h-12">
                      <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    </span>
                  </div>
                </button>
              `;
            })
            .catch(() => {
              wrapper.innerHTML = ``;
            });
        })
    }
    
    redeemForPoints() {
      let variantsToRedeem = [];
      
      Promise.all(this.selectedVariantIds.map(variant_id => loyaltyApi.buyWithPoints(variant_id, {})
          .then(res => {
            variantsToRedeem.push(res);
          }))
        ).then(() => {
          let bundleData;
          fetch('?section_id=bundle-data')
            .then((response) => response.text())
            .then((text) => {
              bundleData = new DOMParser().parseFromString(text, "text/xml")?.querySelector('script')?.innerHTML;
              if (bundleData) {
                bundleData = JSON.parse(bundleData);
              }              
            })
            .then(() => {
              if (!bundleData) return;
              
              const bundleId = crypto.randomUUID();
              const data = {
                items: variantsToRedeem.map(({ variant_id, points_used, key, redemption_id }) => ({
                  'id': variant_id,
                  'quantity': 1,
                  'properties': {
                    ...bundleData,
                    _bundle_id: `${bundleId}`,
                    _bundled_products: `${variantsToRedeem.map(({ variantId }) => variantId).join(',')}`,
                    _bundle_size: this.bundleSize,
                    _bundle_title: `${this.bundleTitle}`,
                    _RedemptionKey: key,
                    _RedemptionId: redemption_id,
                    _RedemptionBundle: bundleId,
                    ['Points Used']: points_used
                  }
                })),
                sections: ['minicart']
              };
                
              this.bulkAddToCart(data);
            });
        })
        
        
    }
    
    createObserver() {
      const observer = new MutationObserver(debounce(() => this.updateSelectedProducts(), 500));
      
      observer.observe(this, {
        subtree: true,
        childList: true,
        attributeFilter: ['data-value']
      });
    }
  }
  
  customElements.define('custom-bundler', CustomBundler);
}